<template>
  <section class="section is-paddingless">
    <div class="container" style="max-width: 500px;">
      <div class="columns is-gapless is-mobile is-marginless is-paddingless">
        <div class="column">
          <div style="height: 18px;"></div>
          <img alt="JizoTokei logo" src="jizotokei.svg" style="margin-left: 12px; height: 20px;">
          <div style="height: 4px;"></div>
        </div>
      </div>
      <div class="columns is-gapless is-mobile is-marginless is-paddingless">
        <div class="column is-marginless is-paddingless">
          <img v-bind:src="imgpass" style="vertical-align: bottom;" />
        </div>
      </div>
      <div class="columns is-gapless is-mobile is-marginless is-paddingless">
        <div class="column" style="overflow: hidden;">
          <img class="blur" v-bind:src="imgpass2" style="vertical-align: bottom;" />
        </div>
      </div>
      <div class="columns is-gapless is-mobile is-marginless is-paddingless">
        <div class="column" style="overflow: hidden;">
          <img class="blur" v-bind:src="imgpass3" style="vertical-align: bottom;" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import dayjs from 'dayjs'
import md5 from 'js-md5'
export default {
  name: 'app',
  components: {},
  data: function () {
    return {
      timer: '',
      tt: '',
      tt2: '',
      tt3: ''
    }
  },
  computed: {
    imgpass: function () {
      return "/" + "i" + "m" + "g" + "/" + this.tt + md5(this.tt + "b" + "u" + "i" + "l" + "t" + "w" + "i" + "t" + "h" + "p" + "r" + "o" + "c" + "e" + "s" + "s" + "i" + "n" + "g") + "/" + "m" + "e" + "d" + "i" + "u" + "m" + "/" + this.tt + "." + "j" + "p" + "g"
    },
    imgpass2: function () {
      return "/" + "i" + "m" + "g" + "/" + this.tt2 + md5(this.tt2 + "b" + "u" + "i" + "l" + "t" + "w" + "i" + "t" + "h" + "p" + "r" + "o" + "c" + "e" + "s" + "s" + "i" + "n" + "g") + "/" + "m" + "e" + "d" + "i" + "u" + "m" + "/" + this.tt2 + "." + "j" + "p" + "g"
    },
    imgpass3: function () {
      return "/" + "i" + "m" + "g" + "/" + this.tt3 + md5(this.tt3 + "b" + "u" + "i" + "l" + "t" + "w" + "i" + "t" + "h" + "p" + "r" + "o" + "c" + "e" + "s" + "s" + "i" + "n" + "g") + "/" + "m" + "e" + "d" + "i" + "u" + "m" + "/" + this.tt3 + "." + "j" + "p" + "g"
    }
  },
  created: function() {
    this.updateTT()
    this.timer = setInterval(this.updateTT, 1000)
  },
  methods: {
    updateTT: function() {
      console.log(this.tt)
      this.tt  = this.ct(0)
      this.tt2 = this.ct(1)
      this.tt3 = this.ct(2)
    },
    cancelAutoUpdate: function() { clearInterval(this.timer) },
    ct: function (num) {
      return dayjs().add(num, 'minutes').format('H' + 'H' + 'm' + 'm')
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>

<style>
.blur {
  filter: grayscale(100%);
  opacity: 0.8;
}
</style>
